import { Alert, AlertTitle, Box, Typography } from "@mui/material";
import { CardErrorsResponse } from "tng-address-collection-shared/types/apiTypes.ts";
import { useTranslator } from "../i18n/translator.ts";
import { ProjectLinkCell } from "./ProjectLinkCell.tsx";

export const ProjectsWithoutShepherdAlert = ({
  projects,
}: {
  projects: CardErrorsResponse["projectsWithoutShepherd"];
}) => {
  const translate = useTranslator();

  if (projects.length === 0) return null;

  return (
    <Alert severity="warning">
      <AlertTitle>{translate("projectsWithoutShepherd")}</AlertTitle>
      <Typography variant="body2">
        {translate("projectsWithoutShepherdHint")}
      </Typography>
      <Box component="ul" sx={{ marginBottom: 0 }}>
        {projects.map(({ id, displayName }) => (
          <li key={id}>
            <ProjectLinkCell id={id} name={displayName} />
          </li>
        ))}
      </Box>
    </Alert>
  );
};
